import React, { useContext, useState, createContext } from "react";
import { useIonModal } from "@ionic/react";
import EventView from "views/modals/eventView";
import Paywall from "views/modals/paywall";

const ModalContext = createContext();

export function ModalContextProvider({ children }) {
  const openModal = (event) => {
    setEventModalEvent(event);
    present({
      onDidDismiss: () => {
        dismiss();
      },
      breakpoints: [0, 0.2, 0.5, 1],
      initialBreakpoint: 0.5,
      backdropDismiss: false,
      backdropBreakpoint: 0.5,
      cssClass: "eventModal",
    });
  };

  const closeModal = () => {
    setEventModalEvent(null);
    dismiss();
  };

  const openPaywallModal = () => {
    presentPaywall({
      onDidDismiss: () => {
        dismissPaywall();
      },
    });
  };

  const closePaywallModal = () => {
    dismissPaywall();
  };

  const [newLeagueDialog, setNewLeagueDialog] = useState(false);
  const [eventModal, setEventModal] = useState(false);
  const [eventModalEvent, setEventModalEvent] = useState(null);
  const [present, dismiss] = useIonModal(
    <EventView event={eventModalEvent} closeModal={closeModal} />,
    {
      onDismiss: () => closeModal(),
    }
  );
  const [presentPaywall, dismissPaywall] = useIonModal(
    <Paywall closeModal={closePaywallModal} />,
    {
      onDismiss: () => closePaywallModal(),
    }
  );

  return (
    <ModalContext.Provider
      value={{
        newLeagueDialog,
        setNewLeagueDialog,
        eventModal,
        setEventModal,
        openModal,
        closeModal,
        eventModalEvent,
        setEventModalEvent,
        openPaywallModal,
        closePaywallModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}

export function useModalContext() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
}
